import { render, staticRenderFns } from "./GameZone.vue?vue&type=template&id=44c6394e&scoped=true"
import script from "./GameZone.vue?vue&type=script&lang=ts"
export * from "./GameZone.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./GameZone.vue?vue&type=style&index=0&id=44c6394e&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "44c6394e",
  "46e5dd7a"
  
)

export default component.exports